import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { ChartOptions, CategoryScale, LinearScale, Chart } from 'chart.js';
import { BaseChartDirective } from 'ng2-charts';

@Component({
    standalone: true,
    imports: [BaseChartDirective],
    selector: 'app-top-factory-hitters-bar-chart',
    templateUrl: './top-factory-hitters-bar-chart.component.html',
    styleUrls: ['./top-factory-hitters-bar-chart.component.scss']
})
export class TopFactoryHittersBarChartComponent implements OnInit {
    constructor() {
        Chart.register(CategoryScale, LinearScale);
    }

    public barChartOptions: ChartOptions = {
        scales: {
            y: {
                stacked: false,
                beginAtZero: true
            }
        },
        responsive: true,
        maintainAspectRatio: true
    };

    @Input() barChartData: any[];
    @Input() barChartLabels: string[];

    public barChartLegend = false;

    ngOnInit() { }

    ngOnChanges(changes: SimpleChanges) { }
}
